import { useQuery } from '@tanstack/react-query';
import { callApi } from '../../../shared/api';
import { teamsModel } from '../../../features/teams';
import { useSelector } from 'react-redux';

type Props = {
  search?: string;
  type: 'team' | 'personal' | 'all';
};

export const useCallRecordings = ({ search, type }: Props) => {
  const currentTeam = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  return useQuery({
    ...callApi.getCallRecordsQueryOptions({
      teamId: currentTeam.id,
      search,
      type,
    }),
    enabled: !!search,
  });
};
